import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import About from "./pages/About"; // Import About page
import OurTeam from "./pages/OurTeam";
import Partners from "./pages/Partners";
import Ourinitiatives from "./pages/Ourinitiatives";
import MembershipPage from "./pages/MembershipPage"; // Ensure correct import path
import EventsPage from "./pages/EventsPage";
import BlogsPage from "./pages/BlogsPage";
import SchemesPage from "./pages/SchemesPage";
import MSMENews from "./pages/MSMENews";
import ContactUs from "./pages/ContactUs";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import WhatsAppFloatButton from "./components/WhatsAppFloatButton";
import MasainMedia from "./pages/MasainMeida"; // Ensure correct import path
import OurMember from "./pages/OurMember";
import TermsAndConditions from "./pages/TermsAndConditions";
import CancellationAndRefund from "./pages/CancellationAndRefund";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import EventRegistrationPage from './pages/EventRegistrationPage';
import MahagrowthPage from "./pages/MahagrowthPage";
import MASAAwards from "./pages/MASAAwards";
import AwardRegistration from './pages/AwardRegistration';
import EventFormPage from "./pages/EventFormPage";
import ChapterPage from "./pages/ChapterPage";
import MasaKalptaruPage from "./pages/MasaKalptaruPage";
import MyPowerBrandPage from "./pages/MyPowerBrandPage";
import BharatStartupGrandChallengePage from "./pages/BharatStartupGrandChallengePage";
import MSMETimesPage from "./pages/MSMETimesPage";
import AccelerationProgram from "./pages/AccelerationProgram";
import NiveshManthan from "./pages/NiveshManthan";
import FinancialLiteracyWorkshop from "./pages/FinancialLiteracyWorkshop";
import MASAYouthAmbassadors from "./pages/MASAYouthAmbassadors";
// import IPYatraProgramme from "./pages/Programme";
import ProgramPage from "./pages/Programme";



function App() {

  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<OurTeam />} />
        <Route path="/masainmedia" element={<MasainMedia />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/CancellationAndRefund" element={<CancellationAndRefund />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/event-registration" element={<EventRegistrationPage />} />
        <Route path="/mahagrowth" element={<MahagrowthPage />} />

        {/* Additional Routes */}

        <Route path="/Partners" element={<Partners />} />
        <Route path="/Ourinitiatives" element={<Ourinitiatives />} />
        <Route path="/MASAAwards" element={<MASAAwards />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/BlogsPage" element={<BlogsPage />} />
        <Route path="/MSMENews" element={<MSMENews />} />
        <Route path="/SchemesPage" element={<SchemesPage />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ourmembers" element={<OurMember />} />

        <Route path="/MSMEKalptaru" element={<MasaKalptaruPage />} />
        <Route path="/MyPowerBrand" element={<MyPowerBrandPage />} />
        <Route path="/MSMETimes" element={<MSMETimesPage />} />
        <Route path="/AccelerationProgram" element={<AccelerationProgram />} />
        <Route path="/NiveshManthan" element={<NiveshManthan />} />
        <Route path="/Workshop/:programName" element={<FinancialLiteracyWorkshop />} />
        <Route path="/MASAYouthAmbassadors" element={<MASAYouthAmbassadors />} />


       <Route path="/programme/:programName" element={<ProgramPage />} />
        <Route path="/Programme" element={<ProgramPage />} />

        <Route path="/AwardRegistration/:id" element={<AwardRegistration />} />
        <Route path="/eventform/:eventId" element={<EventFormPage />} />
         <Route path="/BharatGrandStartupChallenge" element={<BharatStartupGrandChallengePage />} />
       {/* // In your routes configuration */}
        <Route path="/chapters/:chapterName" element={<ChapterPage />} />



        {/* Protected Dashboard Route */}

      </Routes>
      <WhatsAppFloatButton />
    </div>

  );
}

export default App;
